export default __webpack_public_path__ + "static/media/MollyLovelace.afeb5c55.png";